import { Link } from "react-router-dom";

export interface CrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items: CrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.path + item.label} className="flex items-center gap-x-2">
              {isLast ? (
                <span aria-current="page" className="text-foreground-800 font-medium">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              )}
              {!isLast && <span className="text-foreground-300">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}